import { render, staticRenderFns } from "./TestimonialEditTabInformation.vue?vue&type=template&id=535367f8&"
import script from "./TestimonialEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./TestimonialEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports